<template>
    <section>
        <div v-for="position in myPositions" :key="position.id" class="position">
            <span class="tag year">{{ position.year }}</span>
            <div class="role">{{ position.role }}</div>
          <div class="company">{{ position.company }}<span v-if="position.contact == true">, <a href="#footer" v-scroll-to="'#footer'">{{ $t('cta') }}</a></span></div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Positions",
        data () {
            return {}
        },
        props: {
            myPositions: {
                type: Array,
                default: () => { return []; }
            }
        },
    }
</script>

<style lang="sass" scoped>
    .position
        width: auto
        display: flex
        flex-direction: column
        height: 200px
        justify-content: space-between
        align-items: center
        text-align: center
        margin: 35vh 0

        .role
            font-weight: bold
            font-size: 60px
            line-height: 72px
            color: $dark

        .company
            font-weight: bold
            font-size: 28px
            line-height: 52px
            color: $green

            a
              color: $green

        @media screen and (max-width: $mobile-break-point)
            height: 140px
            margin: 25vh 0

            .role
                font-size: 40px
                line-height: 48px
            .company
                font-size: 18px
                line-height: 34px
</style>